import script from "./SearchBrandTermsToPause.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchBrandTermsToPause.vue?vue&type=script&setup=true&lang=js"

import "./SearchBrandTermsToPause.vue?vue&type=style&index=0&id=332d9cac&lang=css"

const __exports__ = script;

export default __exports__